import axios from 'axios';
// import ReactGA from 'react-ga';
import * as ActionCreators from './actionCreators';

export function showHideAlert() {
  return dispatch => {
    dispatch(ActionCreators.changeAlertStatus(true));
    setTimeout(() => {
      dispatch(ActionCreators.changeAlertStatus(false));
      dispatch(ActionCreators.toggleDelayDisplayAlert(false));
    }, 5000);
  };
}

export function getUserInfo(accountInfo, locale) {
  return (dispatch, getState) => {
    const headers = Object.assign(
        {
          Accept: 'application/json',
          Authorization: `Bearer ${getState().accessToken}`,
        },
        locale ? {'Accept-Language': locale} : null);
    axios
      .get(`${getState().basePath}/api/invites/${accountInfo}`, {
        headers
      })
      .then(response => {
        if (response.data.sent) {
          console.log('RESPONSE DATA:');
          console.log(response.data);
          dispatch(ActionCreators.updateInviteUserInfo(response.data));
          dispatch(ActionCreators.toggleInvitesInfoReceived(true));
        } else {
          const newData = response.data;
          newData.sent = [];
          dispatch(ActionCreators.updateInviteUserInfo(newData));
        }
        // // Google Analytics
        // if (response.data.user && response.data.user.stp) {
        //   const queryParams = window.location.search // eslint-disable-line
        //     ? window.location.search // eslint-disable-line
        //     : '';
        //   ReactGA.initialize(getState().gaAccount);
        //   ReactGA.set({ dimension1: response.data.user.stp });
        //
        //   if (response.data.href.indexOf('/leader/invites') !== -1) {
        //     ReactGA.pageview(`/leader/invite${queryParams}`);
        //   }
        //
        //   ReactGA.pageview(`/invite${queryParams}`);
        // }
      })
      .catch(() => {
        // TODO - What to do with user view when info is not retrieved
      });
  };
}

export function emailSubmit(postUrl, useV3) {
  const emailPattern = /^(([\w '-.&]*<[^,;\s@<>]+@[^\s@<>]+\.[^\s@,;<>]+>(\s*[,;]\s*|$))|([^,;\s@<>]+@[^\s@<>]+\.[^\s@,;<>]+(\s*[,;]\s*|$)))+$/i;
  const emailInputBox = document.querySelector('textarea[name="coworkers"]'); // eslint-disable-line
  const sentEmailArray = emailInputBox.value
    .replace(/\s+/g, '')
    .replace(/;/g, ',')
    .split(',');
  const emailPayload = { coworkers: {} };

  /**
   * TODO:  check email length here and throw an error if greater than config value.
   */

  // Check for and remove trailing whitespace
  if (sentEmailArray[sentEmailArray.length - 1] === '') {
    sentEmailArray.pop();
  }

  // Check if empty or invalid emails
  if (sentEmailArray.length === 0) {
    return dispatch => {
      dispatch(ActionCreators.throwError('required'));
      emailInputBox.value = '';
    };
  }


  const emailsAreValid = sentEmailArray.every(email =>
    emailPattern.test(email),
  );

  if (!emailsAreValid) {
    return dispatch => {
      dispatch(ActionCreators.throwError('invalid-format'));
    };
  }

  if (useV3) {
    sentEmailArray.forEach(user => {
      emailPayload.coworkers[user] = null;
    });
  } else {
    emailPayload.coworkers = sentEmailArray;
  }

  return dispatch => {
    dispatch(ActionCreators.updateInputAreaHeight(''));
    dispatch(postEmailInvitations(emailPayload, sentEmailArray, postUrl)); // eslint-disable-line
    emailInputBox.value = '';
  };
}

export function postEmailInvitations(emailPayload, sentEmailArray, postUrl) {
  return (dispatch, getState) => {
    if (sentEmailArray.length === 0) {
      dispatch(ActionCreators.throwError('required'));
    }// Check if email length is greater than 75
    else if (sentEmailArray.length > 75) {
      dispatch(ActionCreators.throwError('Emails-greater-than-75'));
    }
    else {
      dispatch(ActionCreators.displaySpinner(true));
      axios
        .post(postUrl, emailPayload, {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${getState().accessToken}`,
          },
        })
        .then(response => {
          dispatch(ActionCreators.throwError(''));
          dispatch(ActionCreators.displaySpinner(false));
          if (!response.data.resend && !response.data.notAllowedEmails) {
            dispatch(ActionCreators.sentEmailAddresses(sentEmailArray));
            dispatch(showHideAlert());
          } else {
            const resendUrl =
              response.data.resend && response.data.resend.action;
            const restrictedEmails =
              response.data.notAllowedEmails && response.data.notAllowedEmails;
            const duplicateEmails =
              response.data.resend &&
              response.data.resend.input.coworkers.options.map(
                obj => obj.value,
              );

            dispatch(
              ActionCreators.addDuplicateInfo(resendUrl, duplicateEmails),
            );
            dispatch(ActionCreators.addRestrictedEmails(restrictedEmails));
            if (duplicateEmails) {
              dispatch(ActionCreators.displayModal('duplicates'));
            } else {
              dispatch(ActionCreators.displayModal('restricted'));
            }

            if (
              sentEmailArray.length !==
              duplicateEmails.length + restrictedEmails.length
            ) {
              const newEmails = sentEmailArray
                .filter(val => duplicateEmails.indexOf(val) === -1)
                .filter(val => restrictedEmails.indexOf(val) === -1);
              dispatch(ActionCreators.toggleDelayDisplayAlert(true));
              dispatch(ActionCreators.sentEmailAddresses(newEmails));
            }
          }
        })
        .catch(() => {
          dispatch(ActionCreators.displaySpinner(false));
          dispatch(ActionCreators.throwError('network-invite'));
        });
    }
  };
}

export function enterPush(postUrl, useV3, event) {
  if (event.key === 'Enter') {
    event.preventDefault();
    return dispatch => {
      dispatch(emailSubmit(postUrl, useV3));
    };
  }
  return () => {};
}

export function expandTextArea() {
  const inputArea = document.querySelector('textarea[name="coworkers"]');
  const scrollLeft =
    window.pageXOffset ||
    (document.documentElement || document.body.parentNode || document.body)
      .scrollLeft;
  const scrollTop =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body)
      .scrollTop;

  return dispatch => {
    setTimeout(() => {
      dispatch(ActionCreators.updateInputAreaHeight(''));
      dispatch(
        ActionCreators.updateInputAreaHeight(`${inputArea.scrollHeight}px`),
      );
      window.scrollTo(scrollLeft, scrollTop);
    }, 0);
  };
}

export function removeDuplicates(delayDisplayAlert) {
  return dispatch => {
    dispatch(ActionCreators.throwError(''));
    dispatch(ActionCreators.displayModal(''));
    dispatch(ActionCreators.addDuplicateInfo('', []));
    if (delayDisplayAlert) {
      dispatch(showHideAlert());
    }
  };
}

export function resendDuplicates(duplicateEmails) {
  const resendObj = {
    coworkers: duplicateEmails.emails,
  };
  return (dispatch, getState) => {
    axios
      .post(duplicateEmails.resendUrl, resendObj, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${getState().accessToken}`,
        },
      })
      .then(() => {
        dispatch(ActionCreators.throwError(''));
        dispatch(ActionCreators.displayModal(''));
        dispatch(ActionCreators.addDuplicateInfo('', []));

        dispatch(showHideAlert());
      })
      .catch(() => {
        dispatch(ActionCreators.throwError('network-duplicates'));
      });
  };
}
